module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/shipping/pda-shipping.component.html
// module id = ../../../../../src/app/agatextscreens/pda/shipping/pda-shipping.component.html
// module chunks = 0